import React from "react"

import OutfitterInfoDesktop from "~components/pages/outfitter/outfitter-info/outfitter-info-desktop"
import OutfitterInfoMobile from "~components/pages/outfitter/outfitter-info/outfitter-info-mobile"
import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"

export default function OutfitterInfo() {
    const { isLargerThanTablet } = useTabletMediaQueries()

    // split these into 2 components because the destop and mobile versions have different layouts and designs
    // we should try to avoid this as much as possible to keep the code DRY
    return isLargerThanTablet ? (
        <OutfitterInfoDesktop />
    ) : (
        <OutfitterInfoMobile />
    )
}
